import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CoverPictureQuery: GraphQLTaggedNode = graphql`
	query CoverPictureQuery($contentId: ID, $status: [String], $draftShareId: String) {
		content(id: $contentId, draftShareId: $draftShareId, status: $status) {
			nodes {
				id
				properties(keys: ["cover-picture-id-draft", "cover-picture-id-published"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
	}
`;

export const CoverPictureFragment: GraphQLTaggedNode = graphql`
	fragment CoverPictureQuery_content on Content {
		id
		coverPictureProperties: properties(
			keys: ["cover-picture-id-draft", "cover-picture-id-published"]
		) {
			nodes {
				id
				key
				value
				version {
					number
				}
			}
		}
	}
`;
